;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { User } from '@qogita/canary-client'
import { TrackingDestination } from '@qogita/tracking'
import { AnalyticsBrowser } from '@segment/analytics-next'
import { browserLogger } from 'src/core/logger/browser'

import { SellersBrowserTrackingEventList } from '../../types'

const analytics = new AnalyticsBrowser()

export function initializeSegment({ writeKey }: { writeKey: string }) {
  return analytics.load(
    {
      writeKey,
      cdnURL: 'https://analytics.qogita.com',
    },
    {
      integrations: {
        'Segment.io': {
          apiHost: 'analyticsapi.qogita.com/v1',
        },
      },
    },
  )
}

/**
 * Call identify any time user attributes change
 */
export async function identifyUser(user: User) {
  try {
    await analytics.identify(user.qid, {
      email: user.email,
      name: user.account,
      createdAt: new Date(user.createdAt).toISOString(),
      company: { name: user.company },
      isKeyAccount: !!user.accountManager,
      sellerStatus: user.sellerStatus,
      pauseReason: user.pauseReason,
      expectedPauseEnd: user.expectedPauseEnd,
    })
  } catch (error) {
    browserLogger.error(error)
  }
}

/**
 * Call clearUser when the user logs out (or when the user changes from authenticated to unauthenticated)
 */
export async function clearUser() {
  try {
    await analytics.reset()
  } catch (error) {
    browserLogger.error(error)
  }
}

export async function trackPageView(pathname: string, queryString: string) {
  try {
    await analytics.page(undefined, pathname, { queryString })
  } catch (error) {
    browserLogger.error(error)
  }
}

export const segmentTrackingDestination =
  new TrackingDestination<SellersBrowserTrackingEventList>({
    defaultEventHandler: (event, properties) => {
      analytics.track(event, properties)
    },
  })
